<template>
    <div class="offers-page">
        <available-offers v-show="section === 'available-offers'"
            :most-popular-subtext="birthdayOffer ? 'Birthday Offer!' : 'Most Popular'"
            :pdo-config="pdoConfig"
            :first-payment-offer="firstPaymentOffer"
            :selected-offer="selectedOffer"
            :settings="$parent.settings"
            :account="account"
            :billing-profile="billingProfile"
            :offers="offers"
            :error="error"
            @clear-error="error = null"
            @select="offerSelected"
            @accept="previewOrAccept">
            <div class="bg-gray-100">
                <div
                    class="p-5 bg-red-50 font-medium text-center border-gray-200 border-b">

                    <div class="mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                        <div v-if="!account.post_dating_payment_allowed">
                            {{ account.first_name }}, due to multiple declines, your next payment must be made today.
                            <br>Or call <a :href='`tel:${data.consumerPortalNumber}`'>{{ data.consumerPortalNumber }}</a>
                        </div>
                        <div v-if="account.post_dating_payment_allowed">
                            {{ account.first_name }}, your previous arrangement declined.
                            <br>Please select a new arrangement below.
                        </div>

                    </div>

                </div>
                <div :class="`px-5 pt-3 pb-3 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4 text-${$root.theme}-800 font-semibold`">

                    <div class="text-center">
                        <a v-if="accountDetails" href="#"
                           @click.prevent="$root.$emit('account-details', accountDetails)" class="text-sm  underline">View
                            account details</a>
                        <a v-if="prelitStatusLanguage" href="#"
                           @click.prevent="$root.$emit('prelit-status', prelitStatusLanguage)"
                           class="text-sm text-red-500 hover:text-gray-700" :class="{ 'ml-2': accountDetails }">
                            <i class="fa fa-info-circle fa-fw"></i>&nbsp; <span class="underline">What happens if I don’t pay?</span>
                        </a>

                        <div v-if="account.account_banner">
                            <a href="#" @click.prevent="$root.$emit('show-credit-report', account.account_banner)"
                                :class="{
                                    [`text-sm text-${$root.theme}-500 hover:text-gray-700`]: true,
                                    'ml-2': accountDetails
                                }">
                                <i class="fa fa-info-circle fa-fw"></i>&nbsp; <span class="underline">How this will effect my credit report?</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <pdo-banner v-if="hasPdo && hasPdoOffers && offers.length && (firstPaymentOffer !== false || extraPaymentOffer !== false)"
                :is-accepted="firstPaymentOffer"
                :extra-is-accepted="extraPaymentOffer"
                @accepted="firstPaymentOffer = true"
                @declined="declinePdoBanner"
            />

            <div class="mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4 px-5 pt-5">
                <h3>Choose your option below:</h3>
            </div>
        </available-offers>

        <payment-authorization
            v-if="section === 'payment-authorization'"
            :account-id="details.account_id"
            :consumer-portal-data="data"
            :transactions="paymentAuthorizationTransactions"
            :template="paymentAuthorizationAgreementTemplate"
            @accepted="accept"
            @canceled="previewDeclined"
        />
        <offer-summary v-else-if="section === 'summary'"
            :consumer-portal-data="data"
            :selected-offer="selectedOffer"
            :payment-date="paymentDate"
            :transactions="transactions"
            :settings="$parent.settings"
            :details="details"
            :account="account"
            :electronic-consent-template="electronicConsentTemplate"
            :electronic-consent-declined-template="electronicConsentDeclinedTemplate"
            :error="error" />
        <div v-if="section === 'available-offers'" class="border-t border-gray-200">

            <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4" v-if="account.has_billing_profile && account.post_dating_payment_allowed">
                <a :href="`${data.consumerPortalBaseUrl}/account`">
                    <button type="button" class="w-full justify-center text-black items-center inline-flex items-center px-3 text-lg pt-4 pb-3 border border-transparent border-gray-300 shadow-sm leading-4 font-medium rounded-md bg-gray-50 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200">
                        Continue to Account Summary
                    </button>
                </a>
            </div>

            <div v-if="false" class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                <a :href="`${data.consumerPortalBaseUrl}/logout`">
                    <button id="logout-button" type="button" class="w-full justify-center text-black items-center inline-flex items-center px-3 text-lg pt-4 pb-3 border border-transparent border-gray-300 shadow-sm leading-4 font-medium rounded-md bg-gray-50 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200">
                        <svg class="-ml-0.5 mr-3 h-4 w-4 mb-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                        </svg>
                        Logout
                    </button>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Mixins from '../mixins';
import PdoMixin from '../mixins/Pdo';
import AvailableOffers from '../components/AvailableOffers';
import OfferSummary from '../components/OfferSummary';
import Moment from 'moment';
import PdoBanner from "../components/PdoBanner.vue";
import PaymentAuthorization from "../components/PaymentAuthorization.vue";

export default {
    mixins: [
        Mixins,
        PdoMixin
    ],

    components: {
        PaymentAuthorization,
        PdoBanner,
        AvailableOffers,
        OfferSummary
    },

    props: [
        'data',
        'account-details',
        'prelit-status-language',
        'referral',
        'account',
        'prop-offers',
        'billing-profile',
    ],

    created() {
        this.fbEvent('InitiateCheckout');

        this.$root.tiny = this.account.tiny;
    },

    mounted() {
        if (this.propOffers) {
            this.offers = this.propOffers;
        }

        if (this.accountDetails) {
            this.$root.$refs.app.setAccountDetails(this.accountDetails);
        }

        if (this.prelitStatusLanguage) {
            this.gtagEvent('show-prelegal-link:offers-page');

            setTimeout(() => {
                this.$root.$emit('prelit-status', this.prelitStatusLanguage);
            }, 500);
        } else if (true) { // left because we might not always show account details here...
            setTimeout(() => {
                this.$root.$refs.app.showAccountDetails();
            }, 500);
        } else {
            this.setOfferTimeouts();
        }

        if (this.account.account_banner) {
            this.gtagEvent('show-credit-report-link:offers-page');
        }
    },

    data() {
        return {
            pageForEvents: 'nsf-offers-page',
            section: 'available-offers',
            emailConfirmed: null,
            offerConfirmed: null,
            selectedOffer: null,
            paymentMethod: null,
            paymentDate: null,
            transactions: [],
            details: null,
            error: '',
            offers: [],
            electronicConsentTemplate: null,
            electronicConsentDeclinedTemplate: null,
            paymentAuthorizationAgreementTemplate: null,
            paymentAuthorizationTransactions: null,
            forPreview: true,
            submittedPaymentMethod: null
        }
    },

    methods: {
        previewDeclined() {
            this.section = 'available-offers';

            this.$root.$refs.app.updatePageName('offers');
        },

        /**
         * @param {Object} selectedOffer
         * @returns {void}
         */
        offerSelected(selectedOffer) {
            this.selectedOffer = selectedOffer;

            this.gtagEvent(`selected-offer`);
            this.gtagEvent(`selected-offer:${this.selectedOffer.type}`);

            this.$http.post(`${this.data.consumerPortalBaseUrl}/api/tracking`, {
                event: 'last-action',
                value: 'selected-nsf-offer:' + this.selectedOffer.type
            }).then(() => {}, e => {});
        },

        previewOrAccept(submittedPaymentMethod) {
            this.forPreview = this.account.obtain_payment_authorization && this.$parent.settings.feature_payment_authorization_agreement;

            return this.accept(submittedPaymentMethod);
        },

        /**
         * @param {Object} submittedPaymentMethod
         * @returns {void}
         */
        accept(submittedPaymentMethod) {
            this.error = '';

            if (typeof submittedPaymentMethod === 'undefined') {
                submittedPaymentMethod = this.paymentMethod;
            } else {
                this.paymentMethod = submittedPaymentMethod;
            }

            // this is for low-payments-multi
            if (!submittedPaymentMethod.amount && typeof this.selectedOffer.amounts !== 'undefined' && this.selectedOffer.amounts.length) {
                submittedPaymentMethod.amount = this.selectedOffer.amounts[0];
            }

            if (this.selectedOffer.down_payment) submittedPaymentMethod.down_payment = this.selectedOffer.down_payment;

            if (!this.selectedOffer.type === 'custom' && submittedPaymentMethod.payment_type === 'full') {
                submittedPaymentMethod.amount = this.account.current_balance;
            }

            this.submitPayment({
                submittedPaymentMethod: {
                    ...submittedPaymentMethod,
                    ...{offer: this.selectedOffer.name, nsf: true},
                    ...{
                        deferred_first_payment: this.data.deals.pdoAccepted ? 'pop-up' : this.firstPaymentOffer ? 'banner' : false,
                        extra_payment: this.data.deals.pdoExtraAccepted,
                        birthday_offer: this.birthdayOffer,
                        timezone: Moment().format('Z')
                    }
                },
                apiUrl: `${this.data.consumerPortalBaseUrl}/api/payments${this.forPreview ? '/preview' : ''}`,
                afterCallback: ({ data }) => {
                    this.transactions = data.transactions;
                    this.details = data.details;

                    if (this.forPreview) {
                        this.forPreview = false;

                        this.paymentAuthorizationAgreementTemplate = data.payment_authorization_agreement_template;
                        this.paymentAuthorizationTransactions = data.transactions;

                        this.section = 'payment-authorization';
                    } else {
                        this.electronicConsentTemplate = data.electronic_consent_template;
                        this.electronicConsentDeclinedTemplate = data.electronic_consent_declined_template;

                        this.gtagEvent('offer-accepted');
                        this.gtagEvent('offer-accepted:' + submittedPaymentMethod.frequency);
                        this.gtagEvent('offer-accepted-referral:' + this.referral);
                        this.fbEvent('Purchase');

                        this.hideChat();

                        this.gtagPurchaseEvent(
                            this.details.account_id,
                            this.details.total,
                            this.details.referral,
                            this.selectedOffer.name,
                            {
                                id: this.details.client_id,
                                name: this.details.client_name,
                                brand: this.details.creditor,
                                category: this.details.referral_type,
                                quantity: this.details.count,
                                price: this.details.average,
                                variant: this.details.segment
                            }
                        );

                        this.section = 'summary';
                    }
                },
                onError: error => {
                    if (error.hasOwnProperty('body')) {
                        if (error.body.hasOwnProperty('errors') && error.body.errors.hasOwnProperty('zip')) {
                            this.error = error.body.errors.zip[0];
                        } else if (error.body.hasOwnProperty('errors')) {
                            this.error = error.body.errors;
                        } else if (error.body.hasOwnProperty('error')) {
                            this.error = error.body.error;
                        }

                        this.section = 'available-offers';

                        setTimeout(() => {
                            let offerElement = document.getElementById('email-error');

                            if (offerElement) {
                                window.scrollTo({
                                    top: offerElement.offsetTop - 20,
                                    behavior: 'smooth'
                                });
                            }
                        }, 750);
                    } else {
                        throw error;
                    }
                }
            });
        },

        /**
         * @param {Boolean} wasConfirmed
         * @returns {void}
         */
        confirmEmail(wasConfirmed) {
            this.emailConfirmed = wasConfirmed;

            setTimeout(this.accept, 350);
        },

        /**
         * @param {Boolean} wasConfirmed
         * @returns {void}
         */
        confirmOffer(wasConfirmed) {
            this.offerConfirmed = wasConfirmed;

            if (this.offerConfirmed) {
                setTimeout(this.accept, 350);
            } else {
                this.offerConfirmed = null;
                this.emailConfirmed = null;
            }
        }
    }
}
</script>
